// src/adminComponents/aDashboard/ADashboard.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import OverallStats from './OverallStats'; 
import Tasks from './Tasks';

const ADashboard = ({ onManageEmployeesClick, onAddTaskClick }) => {
  return (
    <Box sx={{ flexGrow: 1, padding: 3, paddingTop: 0, marginTop: 0 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ color: '#39B54A' }}>
          Dashboard
        </Typography>
      </Box>
      <OverallStats onManageUsersClick={onManageEmployeesClick} />
      <Tasks onAddTaskClick={onAddTaskClick} />
    </Box>
  );
};

export default ADashboard;
